import { useRef, useEffect } from 'react';
import focusTrap from 'modal-focus-trap';

function useFocusTrap() {
  const ref = useRef(null);

  useEffect(() => {
    const destroy = focusTrap(ref?.current);

    return destroy;
  }, []);

  return ref;
}

export default useFocusTrap;
